// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 957 ? "routes" : chunkId) + "-legacy." + {"121":"f1d4d758","957":"a8d10624"}[chunkId] + ".js";
};